import { QueryClient } from '@tanstack/react-query'

import { toast } from '~/elements/Toast'
import { parseBillingError } from '~/features/billing/errors'
import { openBillingBlockedDialog } from '~/features/billing/stores/blocked'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 5 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: false
    },
    mutations: {
      onError(error) {
        if (error instanceof Error) {
          const billingError = parseBillingError(error)
          if (billingError) {
            openBillingBlockedDialog(billingError.reason)
            return
          }
          toast({ variant: 'danger', title: error.message })
        }
      }
    }
  }
})
